import React from 'react'

const Loader = (props: {
  text?: string
  width?: number | 'full'
  height?: number | 'full'
}) => {
  return (
    <div
      className={`${
        props.width && props.width !== 'full' ? 'w-full' : 'w-screen'
      } ${
        props.height && props.height !== 'full'
          ? 'h-full rf-flex-grow'
          : 'h-screen'
      } flex flex-col justify-center items-center rf-text-primary`}
    >
      <div className='mb-8 font-bold text-lg'>
        {props.text ?
          props.text
          :
          'Loading...'
        }
      </div>
      <div className='border-box border-b border-t border-r animate-spin w-16 h-16 border-4 rounded-full' />
    </div>
  )
}

export default Loader
